<script setup>

import { resourceV2 } from '@/composables/resource';
import { useRoute } from 'vue-router';

import ListingContent from '@/components/Secondary/Marketplace/ListingContent.vue';
import ListingMedia from '@/components/Secondary/Marketplace/ListingMedia.vue';
import { onBeforeMount } from 'vue';

const route = useRoute();
const listing = resourceV2({
    url: `/api/marketplace/listings/${route.params.id}`,
});
// const listing = {
//     data: {
//         save_exists: true,
//         title: 'One Bedroom apartment',
//         description: "DAF LF 45 7.5t camper lorry mobilehome total off grid living. \n £18995 Fantastic well built conversion that has had a recent refurbishment and upgrade \n Advertising for friend due to lost account",
//         price: '5000',
//         files: [
//             {
//                 url: 'https://scontent-lhr6-2.xx.fbcdn.net/v/t45.5328-4/491770853_1190131242321406_5890031574732244427_n.jpg?stp=dst-jpg_s960x960_tt6&_nc_cat=104&ccb=1-7&_nc_sid=247b10&_nc_ohc=kvWlKDimRLYQ7kNvwFzvane&_nc_oc=Adlp34j6FlB7hVWWXT14xEEL0kJQNAqL1XN79i-vd9XlZocX1rmWJy60A99rtw0bRr8&_nc_zt=23&_nc_ht=scontent-lhr6-2.xx&_nc_gid=vcD7jrh0svwz165a_tUUXA&oh=00_AfH5hYrq6uXObQDJJbuyHdHoCCdOZ-tNSYyXDsZssB4McQ&oe=681AACC7',
//             },
//             {
//                 url: 'https://scontent-lhr6-2.xx.fbcdn.net/v/t45.5328-4/491763494_697874382685662_3653858187933761018_n.jpg?stp=dst-jpg_s960x960_tt6&_nc_cat=100&ccb=1-7&_nc_sid=247b10&_nc_ohc=e8OQbNRBe20Q7kNvwG1-1_G&_nc_oc=AdlcrOiHxaURLa4_P6nZPDNjugjRNsmy-YlBp7bavjMzkJHxTjLCyrBTL_8rDBwyIgg&_nc_zt=23&_nc_ht=scontent-lhr6-2.xx&_nc_gid=BuEHkX01Z7kepigZWiITew&oh=00_AfEIakbWPQ-Lo0099v4lcGuWlwilysEfFoCHsB0xIYuSGg&oe=68153978'
//             },
//             {
//                 url: 'https://corperland.ng/files/01jsxxd01gv7gmr06tac2x0xt0',
//             }
//         ],
//         created_at: '2025-05-01T14:09:23.000000Z',
//         location: {
//             state: 'Lagos',
//         },
//         seller: {
//             id: '01jdt368w8v5rpjx3jc49z5yxg',
//             is_me: true,
//             active_listings_count: 20,
//             created_at: '2024-11-28T19:15:28.000000Z',
//             verification: null,
//             profile: {
//                 verified: true,
//                 is_business: true,
//                 name: 'Corperland Shop',
//                 description: 'We sell all things NYSC',
//                 address: 'Satellite Town',
//                 state: {
//                     name: 'Lagos',
//                 },
//                 image: {
//                     url: 'http://localhost/files/01jsshsbw05vt9jtmzrxtt6t5h',
//                 }
//             },
//         }
//     }
// }

onBeforeMount(() => {
    listing.fetch();
});
</script>

<template>
    <layout-main>
        <template v-if="$store.state.deviceType === 'desktop'">
            <layout-content size="lg">
                <content-body>
                    <ListingMedia v-if="listing.loadState === 'ready'" :files="listing.data.files" />
                </content-body>
            </layout-content>
            <layout-content size="sm">
                <content-header hide-border>
                    <top-nav>
                        <top-nav-back />
                    </top-nav>
                </content-header>

                <content-body>
                    <template v-if="listing.loadState === 'ready'" >
                        <ListingContent :listing="listing.data" @refresh="listing.fetch()" />
                    </template>

                    <app-layout-skeleton v-else-if="listing.loadState === 'loading'" />
                    <app-error-not-found v-else-if="listing.loadState === 'missing'" />
                    <app-error-default v-else-if="listing.loadState === 'error'" />
                </content-body>
            </layout-content>
        </template>
        <template v-else>
            <layout-content>
                <content-header>
                    <top-nav>
                        <top-nav-back />
                    </top-nav>
                </content-header>
                <content-body>
                    <template v-if="listing.loadState === 'ready'">
                        <div class="w-full h-[400px]">
                            <ListingMedia :files="listing.data.files" />
                        </div>
                        <ListingContent :listing="listing.data" @refresh="listing.fetch({ silent: true })" />
                    </template>

                    <app-layout-skeleton v-else-if="listing.loadState === 'loading'" />
                    <app-error-not-found v-else-if="listing.loadState === 'missing'" />
                    <app-error-default v-else-if="listing.loadState === 'error'" />
                </content-body>
            </layout-content>
        </template>
    </layout-main>
</template>

